import { render, staticRenderFns } from "./AutoRegistroInstitucion.vue?vue&type=template&id=132c09b4&scoped=true"
import script from "./AutoRegistroInstitucion.vue?vue&type=script&lang=js"
export * from "./AutoRegistroInstitucion.vue?vue&type=script&lang=js"
import style0 from "./AutoRegistroInstitucion.vue?vue&type=style&index=0&id=132c09b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c09b4",
  null
  
)

export default component.exports